import inferPropertyActionOperationType from 'automation-ui-action-features/actions/set-property/utils/inferPropertyActionOperationType';
import * as PropertyValueTypes from 'automation-ui-flow-core/fields/PropertyValueTypes';
import * as SetPropertyActionOperations from 'automation-ui-action-features/actions/set-property/SetPropertyActionOperations';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const getSetPropertyActionDetailMessage = ({
  actionMetadata,
  isActionPreview,
  isAssociation,
  options,
  showAssociationLabel
}) => {
  const operation = inferPropertyActionOperationType(actionMetadata);
  const valueType = actionMetadata.getValueType();
  const isValueEmpty = actionMetadata.getIsValueEmpty();
  switch (operation) {
    case SetPropertyActionOperations.INCREASE:
      {
        const isIncreasing = actionMetadata.getValueAmount() >= 0;
        if (isActionPreview) {
          if (valueType === PropertyValueTypes.INCREMENT) {
            if (isIncreasing) {
              return isAssociation ? /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "automation-ui-action-features.action-features.set-property.INCREASE.action-preview.associated.increase",
                options: options
              }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "automation-ui-action-features.action-features.set-property.INCREASE.action-preview.enrolled.increase",
                options: options
              });
            } else {
              return isAssociation ? /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "automation-ui-action-features.action-features.set-property.INCREASE.action-preview.associated.decrease",
                options: options
              }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "automation-ui-action-features.action-features.set-property.INCREASE.action-preview.enrolled.decrease",
                options: options
              });
            }
          } else {
            return isAssociation ? /*#__PURE__*/_jsx(FormattedReactMessage, {
              message: "automation-ui-action-features.action-features.set-property.INCREASE.action-preview.associated",
              options: options
            }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
              message: "automation-ui-action-features.action-features.set-property.INCREASE.action-preview.enrolled",
              options: options
            });
          }
        } else {
          if (valueType === PropertyValueTypes.INCREMENT) {
            if (isIncreasing) {
              return isAssociation ? /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "automation-ui-action-features.action-features.set-property.INCREASE.action-detail.associated.increase",
                options: options
              }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "automation-ui-action-features.action-features.set-property.INCREASE.action-detail.enrolled.increase",
                options: options
              });
            } else {
              return isAssociation ? /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "automation-ui-action-features.action-features.set-property.INCREASE.action-detail.associated.decrease",
                options: options
              }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "automation-ui-action-features.action-features.set-property.INCREASE.action-detail.enrolled.decrease",
                options: options
              });
            }
          } else {
            return isAssociation ? /*#__PURE__*/_jsx(FormattedReactMessage, {
              message: "automation-ui-action-features.action-features.set-property.INCREASE.action-detail.associated",
              options: options
            }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
              message: "automation-ui-action-features.action-features.set-property.INCREASE.action-detail.enrolled",
              options: options
            });
          }
        }
      }
    // set property
    default:
      {
        if (isActionPreview) {
          if (isValueEmpty) {
            const message = isAssociation ? 'automation-ui-action-features.action-features.set-property.SET.action-preview.clear-property.associated' : 'automation-ui-action-features.action-features.set-property.SET.action-preview.clear-property.enrolled';
            return /*#__PURE__*/_jsx(FormattedReactMessage, {
              message: message,
              options: options
            });
          } else if (valueType === PropertyValueTypes.STATIC_APPEND_VALUE) {
            if (isAssociation) {
              return showAssociationLabel ? /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "automation-ui-action-features.action-features.set-property.SET.action-preview.static-append-value.associated-label",
                options: options
              }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "automation-ui-action-features.action-features.set-property.SET.action-preview.static-append-value.associated",
                options: options
              });
            }
            return /*#__PURE__*/_jsx(FormattedReactMessage, {
              message: "automation-ui-action-features.action-features.set-property.SET.action-preview.static-append-value.enrolled",
              options: options
            });
          } else if (valueType === PropertyValueTypes.TIMESTAMP) {
            if (isAssociation) {
              return showAssociationLabel ? /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "automation-ui-action-features.action-features.set-property.SET.action-preview.date-of-step.associated-label",
                options: options
              }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "automation-ui-action-features.action-features.set-property.SET.action-preview.date-of-step.associated",
                options: options
              });
            }
            return /*#__PURE__*/_jsx(FormattedReactMessage, {
              message: "automation-ui-action-features.action-features.set-property.SET.action-preview.date-of-step.enrolled",
              options: options
            });
          } else if (valueType === PropertyValueTypes.FETCHED_OBJECT_PROPERTY || valueType === PropertyValueTypes.ENROLLMENT_EVENT_PROPERTY || valueType === PropertyValueTypes.ENROLLMENT_DATASET_COLUMN) {
            if (isAssociation) {
              return showAssociationLabel ? /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "automation-ui-action-features.action-features.set-property.SET.action-preview.data-token.associated-label",
                options: options
              }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "automation-ui-action-features.action-features.set-property.SET.action-preview.data-token.associated",
                options: options
              });
            }
            return /*#__PURE__*/_jsx(FormattedReactMessage, {
              message: "automation-ui-action-features.action-features.set-property.SET.action-preview.data-token.enrolled",
              options: options
            });
          } else if (valueType === PropertyValueTypes.OBJECT_PROPERTY) {
            if (isAssociation) {
              return showAssociationLabel ? /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "automation-ui-action-features.action-features.set-property.SET.action-preview.object-property.associated-label",
                options: options
              }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "automation-ui-action-features.action-features.set-property.SET.action-preview.object-property.associated",
                options: options
              });
            }
            return /*#__PURE__*/_jsx(FormattedReactMessage, {
              message: "automation-ui-action-features.action-features.set-property.SET.action-preview.object-property.enrolled",
              options: options
            });
          } else {
            if (isAssociation) {
              return showAssociationLabel ? /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "automation-ui-action-features.action-features.set-property.SET.action-preview.associated-label",
                options: options
              }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "automation-ui-action-features.action-features.set-property.SET.action-preview.associated",
                options: options
              });
            }
            return /*#__PURE__*/_jsx(FormattedReactMessage, {
              message: "automation-ui-action-features.action-features.set-property.SET.action-preview.enrolled",
              options: options
            });
          }
        } else {
          if (valueType === PropertyValueTypes.STATIC_APPEND_VALUE) {
            if (isAssociation) {
              return showAssociationLabel ? /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "automation-ui-action-features.action-features.set-property.SET.action-detail.static-append-value.associated-label",
                options: options
              }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "automation-ui-action-features.action-features.set-property.SET.action-detail.static-append-value.associated",
                options: options
              });
            }
            return /*#__PURE__*/_jsx(FormattedReactMessage, {
              message: "automation-ui-action-features.action-features.set-property.SET.action-detail.static-append-value.enrolled",
              options: options
            });
          } else if (valueType === PropertyValueTypes.TIMESTAMP) {
            if (isAssociation) {
              return showAssociationLabel ? /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "automation-ui-action-features.action-features.set-property.SET.action-detail.date-of-step.associated-label",
                options: options
              }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "automation-ui-action-features.action-features.set-property.SET.action-detail.date-of-step.associated",
                options: options
              });
            }
            return /*#__PURE__*/_jsx(FormattedReactMessage, {
              message: "automation-ui-action-features.action-features.set-property.SET.action-detail.date-of-step.enrolled",
              options: options
            });
          } else if (valueType === PropertyValueTypes.FETCHED_OBJECT_PROPERTY || valueType === PropertyValueTypes.ENROLLMENT_EVENT_PROPERTY || valueType === PropertyValueTypes.ENROLLMENT_DATASET_COLUMN) {
            if (isAssociation) {
              return showAssociationLabel ? /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "automation-ui-action-features.action-features.set-property.SET.action-detail.data-token.associated-label",
                options: options
              }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "automation-ui-action-features.action-features.set-property.SET.action-detail.data-token.associated",
                options: options
              });
            }
            return /*#__PURE__*/_jsx(FormattedReactMessage, {
              message: "automation-ui-action-features.action-features.set-property.SET.action-detail.data-token.enrolled",
              options: options
            });
          } else if (valueType === PropertyValueTypes.FIELD_DATA) {
            if (isAssociation) {
              return showAssociationLabel ? /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "automation-ui-action-features.action-features.set-property.SET.action-detail.field-data-value.associated-label",
                options: options
              }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "automation-ui-action-features.action-features.set-property.SET.action-detail.field-data-value.associated",
                options: options
              });
            }
            return /*#__PURE__*/_jsx(FormattedReactMessage, {
              message: "automation-ui-action-features.action-features.set-property.SET.action-detail.field-data-value.enrolled",
              options: options
            });
          } else if (valueType === PropertyValueTypes.OBJECT_PROPERTY) {
            if (isAssociation) {
              return showAssociationLabel ? /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "automation-ui-action-features.action-features.set-property.SET.action-detail.object-property.associated-label",
                options: options
              }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "automation-ui-action-features.action-features.set-property.SET.action-detail.object-property.associated",
                options: options
              });
            }
            return /*#__PURE__*/_jsx(FormattedReactMessage, {
              message: "automation-ui-action-features.action-features.set-property.SET.action-detail.object-property.enrolled",
              options: options
            });
          } else {
            if (isAssociation) {
              return showAssociationLabel ? /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "automation-ui-action-features.action-features.set-property.SET.action-detail.associated-label",
                options: options
              }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "automation-ui-action-features.action-features.set-property.SET.action-detail.associated",
                options: options
              });
            }
            return /*#__PURE__*/_jsx(FormattedReactMessage, {
              message: "automation-ui-action-features.action-features.set-property.SET.action-detail.enrolled",
              options: options
            });
          }
        }
      }
  }
};